import { styled, css } from "styled-components";
import media from "../../../../styles/mediaQueries";
export const StyledNavigation = styled.nav `
  display: block;
  visibility: hidden;
  position: fixed;
  height: 100%;
  width: 700px;
  background: #eee;
  border-left: 2px solid rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  left: -440px;
  transition: all 0.8s cubic-bezier(0.27, 0.74, 0.32, 1.01);
  padding: 30px 10px;
  z-index: 999;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);

  ${(props) => props.isSearchActive &&
    css `
      background: #fff;
    `}

  ${(props) => props.isExtended &&
    css `
      visibility: visible;
      left: 258px;
    `}

  ${media.up("small") `
    padding: 60px 56px 10px;
  `}

  ${media.down("belowSmall") `
    left: -100%;
    width: calc(100% - 60px);
    max-width: calc(100% - 60px);
  `}

  ${media.only("small", "belowMedium") `
    left: -100%;
    width: calc(100% - 200px);

    ${(props) => props.isExtended &&
    css `
        left: 58px;
      `}
  `}
  ${media.only("medium", "belowLarge") `
    width: 550px;
    padding: 30px 35px;
    left: -100%;
    ${(props) => props.isExtended &&
    css `
        left: 198px;
      `}
  `}
  ${media.only("large", "xlarge") `
    width: 600px;
    padding: 30px 35px;
    ${(props) => props.isExtended &&
    css `
        left: 198px;
      `}
  `}
  ${media.down("small") `
    ${(props) => props.isExtended &&
    css `
        left: 58px;
      `}
  `}
`;
export const SidebarMenuToggle = styled.div `
  position: absolute;
  right: 3.5em;
  opacity: 0;
  top: 1em;
  transition: all 0.5s ease-in-out;
  z-index: 9999;
  display: none;

  ${media.up("medium") `
    display: block;
  `}

  svg {
    color: #000;
    fill: #000;
    width: 15px;
    height: 15px;
    display: inline-block;
    background-size: 100% !important;
    vertical-align: top;
  }

  ${(props) => props.isExtended &&
    css `
      right: 1.5em;
      opacity: 1;
      transition: all 1s ease-in-out;
      z-index: 10000;
    `}
`;
export const SidebarMenuToggleButton = styled.button `
  display: inline-block;
  color: #555;
  overflow: visible;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 4px;
  box-sizing: border-box;

  border: none;
  margin: 0;
  padding: 0;
  background-color: transparent;
  cursor: pointer;

  line-height: 38px;
  height: 38px;
`;
export const SidebarMenuBlock = styled.div `
  max-width: 1200px;
  position: relative;
  padding-top: 30px;
  ${media.up("small") `
    padding-top: 0;
  `}

  &:before {
    content: " ";
    display: table;
  }
`;
export const SidebarMenuBlockColumn = styled.div `
  width: 100%;
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
  ${media.up("medium") `
    float: left;
  `}
`;
//# sourceMappingURL=style.js.map